import Button from "devextreme-react/button";
import { useContext } from "react";
import { AR, OrderStatus } from "../../../../types/enums";
import { showErrorMessage, showSuccessMessage } from "../../../../utils/messages";
import { MaterialOrderContext } from "../context/MaterialOrderContext";
import { alert, confirm } from "devextreme/ui/dialog";
import { useRequestMaterialCancellation } from "../api/request-material-cancellation";
import { LoadPagePanel } from "../../../../components";

export default function RequestCancellationButton() {

	const { order, refetchOrder } = useContext(MaterialOrderContext);

	const requestMaterialCancellation = useRequestMaterialCancellation(
		order.details.materialOrderID!,
		(result) => {
			if (result.orderStatusID === OrderStatus.Cancelled) {
				showSuccessMessage("The material order has been cancelled");
			}
			else {
				alert("A request has been submitted to the distributor to cancel this order. Once the request has been approved, your order will be cancelled.", "Material Order Cancellation Request");
			}

			refetchOrder();
		},
		(error) => {
			showErrorMessage(error);
		}
	);

	return (
		<>
			<Button
				text="MO Cancellation"
				icon="Inscyth-Cancel"
				visible={order.details.orderStatusID !== OrderStatus.Cancelled &&
					order.details.orderStatusID !== OrderStatus.Closed &&
					!order.details.activeARs.includes(AR.MODistributorToApproveCancelation) &&
					!order.details.purchaseOrders.find((po) => !!po.validatedShipDate) &&
					!order.details.purchaseOrders.find((po) => !!po.validatedDeliveryDate)
				}
				disabled={requestMaterialCancellation.isLoading}
				onClick={() => {
					confirm("Are you sure you want to send a cancellation requested for this material order?", "Request MO Cancellation")
						.then((result) => {
							if (result) {
								requestMaterialCancellation.mutate();
							}
						})
				}}
			>
			</Button>
			<LoadPagePanel visible={requestMaterialCancellation.isLoading} />
		</>
	)
}
